import React, { useState, useEffect, useRef } from "react";
import "../../pages/formulaire/formulaire.css";
import { useNavigate } from "react-router-dom";
const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL_PROD // https://demenagementsamyyhaul.ca/api
    : process.env.REACT_APP_API_URL_DEV; // http://158.69.205.231:3000


const Ramassage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [categoryItems, setCategoryItems] = useState([]);
  const [itemsState, setItemsState] = useState({});
  const [showSummary, setShowSummary] = useState(false);
  const [loading, setLoading] = useState(true);
  const [extraServices, setExtraServices] = useState([]);
  const [isDateUnavailable, setIsDateUnavailable] = useState(false);
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [imageUploadError, setImageUploadError] = useState("");
  // Check if user is authenticated
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userId, setUserId] = useState(null);
  const [guestToken, setGuestToken] = useState(null);
  const navigate = useNavigate();

  const [modeSelection, setModeSelection] = useState(null); // "articles" ou "manuelle"

  const [formData, setFormData] = useState({
    prenom: "",
    nom: "",
    email: "",
    telephone: "",
    adresse_ramassage: "",
    ville_ramassage: "",
    cp_ramassage: "",
    services: [],
    notes: "",
    rgpd: false,
    date_ramassage: "",
    plage_horaire: "",
    type_hebergement_ramassage: "",
    etage_ramassage: "",
    ascenseur_ramassage: "",
    date_debut_custom: "",
    date_fin_custom: "",
    pickupAddressId: null,
    nombre_camions: "",
    nombre_demenageurs: "",
    description_manuelle: "",
  });

  const fieldRefs = useRef({
    prenom: null,
    nom: null,
    email: null,
    telephone: null,
    adresse_ramassage: null,
    ville_ramassage: null,
    cp_ramassage: null,
    images: null,
  });

  // Modifier la fonction nextStep pour inclure la validation de l'étape 2
  const nextStep = () => {
    if (currentStep === 1 && !validateStep1()) return;
    if (currentStep === 2 && !validateStep2()) return;
    setCurrentStep((prev) => Math.min(prev + 1, 3));
  };

  // Check authentication status on component mount
  useEffect(() => {
    console.log("Checking authentication status...");

    const token = localStorage.getItem("authToken");
    const currentUserStr = localStorage.getItem("currentUser");

    if (token && currentUserStr) {
      try {
        const currentUser = JSON.parse(currentUserStr);
        setIsAuthenticated(true);

        if (currentUser.id) {
          setUserId(currentUser.id.toString());
          console.log("User is authenticated with ID:", currentUser.id);

          // Nettoyer le guestToken si l'utilisateur est connecté
          localStorage.removeItem("guestToken");
          setGuestToken(null);
        } else {
          const userIdFromStorage = localStorage.getItem("userId");
          if (userIdFromStorage) {
            setUserId(userIdFromStorage);
            console.log("User ID from separate storage:", userIdFromStorage);
          } else {
            console.warn("User is authenticated but no ID found in storage");
          }
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
      console.log("User is not authenticated - will collect guest info");

      // Initialiser le guestToken pour les non-authentifiés
      const guestToken = manageGuestToken();
      setGuestToken(guestToken);
    }
  }, []);
  // Generate guest token - améliorée
  const generateGuestToken = () => {
    // Générer un UUID-like token pour plus de sécurité
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substr(2, 9);
    const guestToken = `guest_${timestamp}_${random}`;

    console.log("🎫 Guest token generated:", guestToken);
    return guestToken;
  };
  // Gestion améliorée du guestToken
  const manageGuestToken = () => {
    // Vérifier si un guestToken existe déjà dans le localStorage
    const existingToken = localStorage.getItem("guestToken");

    if (existingToken) {
      console.log("🎫 Existing guest token found:", existingToken);
      return existingToken;
    }

    // Sinon, générer un nouveau token
    const newToken = generateGuestToken();
    localStorage.setItem("guestToken", newToken);
    console.log("🎫 New guest token created and stored:", newToken);
    return newToken;
  };
  // Fonctions pour gérer l'upload d'images
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);

    // Validation des fichiers
    const validFiles = files.filter((file) => {
      // Vérifier le type de fichier
      const validTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/webp",
      ];
      if (!validTypes.includes(file.type)) {
        alert(
          `Le fichier ${file.name} n'est pas une image valide. Formats acceptés: JPEG, PNG, GIF, WebP`
        );
        return false;
      }

      // Vérifier la taille (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert(
          `Le fichier ${file.name} est trop volumineux. Taille maximale: 5MB`
        );
        return false;
      }

      return true;
    });

    // Limiter à 5 images maximum
    const totalImages = uploadedImages.length + validFiles.length;
    if (totalImages > 5) {
      alert("Vous ne pouvez pas uploader plus de 5 images");
      validFiles.splice(5 - uploadedImages.length);
    }

    // Créer des URLs pour l'aperçu
    const newImages = validFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      name: file.name,
      size: (file.size / 1024 / 1024).toFixed(2) + " MB",
    }));

    setUploadedImages((prev) => [...prev, ...newImages]);
  };

  const removeImage = (index) => {
    setUploadedImages((prev) => {
      const newImages = [...prev];
      // Libérer l'URL de l'image supprimée
      URL.revokeObjectURL(newImages[index].preview);
      newImages.splice(index, 1);
      return newImages;
    });
  };

  // Fonction pour uploader les images vers le serveur - VERSION AMÉLIORÉE
  // Fonction uploadImagesToServer - VERSION CORRIGÉE
  const uploadImagesToServer = async () => {
    if (!uploadedImages || uploadedImages.length === 0) {
      console.warn("⚠️ Aucune image sélectionnée");
      return [];
    }

    const formData = new FormData();
    uploadedImages.forEach((image) => {
      formData.append("images", image.file);
    });

    try {
      const response = await fetch(
        `${API_BASE_URL}/test-upload/multiple-images`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Erreur détaillée du serveur:", errorText);
        throw new Error(
          `Erreur lors de l'upload des images: ${response.status} - ${errorText}`
        );
      }

      const data = await response.json();
      console.log("✅ Images uploadées avec succès:", data);

      // EXTRACTION CORRECTE DES URLs - VERSION AMÉLIORÉE
      let imageUrls = [];

      if (data.data && Array.isArray(data.data)) {
        imageUrls = data.data.map((img) => img.secure_url || img.url);
      } else if (Array.isArray(data)) {
        imageUrls = data.map((img) => img.secure_url || img.url);
      } else if (data.images && Array.isArray(data.images)) {
        imageUrls = data.images.map((img) => img.secure_url || img.url);
      } else {
        console.error("❌ Format de réponse d'upload invalide:", data);
        throw new Error("Format de réponse d'upload invalide");
      }

      // FILTRER LES URLs NULL/UNDEFINED
      imageUrls = imageUrls.filter((url) => url && url.trim() !== "");

      console.log("📸 URLs extraites et filtrées:", imageUrls);
      return imageUrls;
    } catch (error) {
      console.error("❌ Erreur upload images:", error);
      throw error;
    }
  };
  // Fonction de validation améliorée pour l'étape 2
  const validateStep2 = () => {
    // Vérifier qu'au moins une image est uploadée
    if (uploadedImages.length === 0) {
      setImageUploadError(
        "Veuillez uploader au moins une photo des articles à ramasser"
      );
      setTimeout(() => {
        fieldRefs.current.images?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
      return false;
    }

    // Vérifier que les images ne sont pas trop volumineuses
    const oversizedImages = uploadedImages.filter(
      (image) => image.file.size > 5 * 1024 * 1024
    );
    if (oversizedImages.length > 0) {
      setImageUploadError("Certaines images sont trop volumineuses (max 5MB)");
      return false;
    }

    setImageUploadError("");
    return true;
  };
  // Check authentication status on component mount
  useEffect(() => {
    console.log("Checking authentication status...");

    const token = localStorage.getItem("authToken");
    const currentUserStr = localStorage.getItem("currentUser");

    if (token && currentUserStr) {
      try {
        const currentUser = JSON.parse(currentUserStr);
        setIsAuthenticated(true);

        if (currentUser.id) {
          setUserId(currentUser.id.toString());
          console.log("User is authenticated with ID:", currentUser.id);
        } else {
          const userIdFromStorage = localStorage.getItem("userId");
          if (userIdFromStorage) {
            setUserId(userIdFromStorage);
            console.log("User ID from separate storage:", userIdFromStorage);
          } else {
            console.warn("User is authenticated but no ID found in storage");
          }
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
      console.log("User is not authenticated - will collect guest info");
    }
  }, []);

// Pre-fill user information when authenticated - VERSION CORRIGÉE
useEffect(() => {
  if (isAuthenticated) {
    const currentUserStr = localStorage.getItem("currentUser");
    if (currentUserStr) {
      try {
        const currentUser = JSON.parse(currentUserStr);
        
        console.log("🔄 Pre-filling Livraison form with user data:", {
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          email: currentUser.email,
          tel: currentUser.tel,
          phone: currentUser.phone,
          telephone: currentUser.telephone
        });

        // Fonction helper pour extraire les valeurs en gérant null/undefined
        const getValue = (value) => (value !== null && value !== undefined ? value : "");

        setFormData((prev) => ({
          ...prev,
          prenom: getValue(currentUser.firstName || currentUser.prenom),
          nom: getValue(currentUser.lastName || currentUser.nom),
          email: getValue(currentUser.email),
          telephone: getValue(currentUser.tel || currentUser.phone || currentUser.telephone),
        }));

      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }
}, [isAuthenticated]);
  // Fetch initial data (categories, items, services)
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        console.log("Fetching initial data...");
        setLoading(true);

        // ✅ Fetch categories
        const categoriesResponse = await fetch(`${API_BASE_URL}/category`);
        const categoriesData = await categoriesResponse.json();
        console.log("Categories fetched:", categoriesData);

        // ✅ Fetch category items (corrigé)
        const itemsResponse = await fetch(`${API_BASE_URL}/category-item`);
        const itemsData = await itemsResponse.json();
        console.log("Category items fetched:", itemsData);

        // ✅ Fetch extra services (corrigé)
        const servicesResponse = await fetch(`${API_BASE_URL}/extra-service`);
        const servicesData = await servicesResponse.json();
        console.log("Extra services fetched:", servicesData);

        // 🟩 Sécurise les valeurs avant de les utiliser
        setCategories(categoriesData.data?.categories || []);
        setCategoryItems(itemsData.data?.categoryItems || []);

        if (
          servicesData.statusCode === 200 &&
          Array.isArray(servicesData.data?.extraServices)
        ) {
          const validServices = servicesData.data.extraServices.filter(
            (service) =>
              service &&
              service.id &&
              service.name &&
              typeof service.name === "string"
          );
          setExtraServices(validServices);
          console.log("Valid extra services loaded:", validServices.length);
        } else {
          console.warn("No valid extra services found in API response");
          setExtraServices([]);
        }

        // ✅ Initialise les items
        const initialState = {};

        (itemsData.data?.categoryItems || []).forEach((item) => {
          initialState[item.id] = {
            id: item.id,
            checked: false,
            quantity: 1,
            name: item.name,
            icon: item.icon,
            categoryId: item.category.id,
          };
        });

        (categoriesData.data?.categories || []).forEach((category) => {
          initialState[category.id] = {
            id: category.id,
            checked: false,
            quantity: 1,
            name: category.name,
            icon: category.icon,
            categoryId: category.id,
          };
        });

        setItemsState(initialState);
        console.log("Initial data loaded successfully");
        setLoading(false);
      } catch (error) {
        console.error("Error fetching initial data:", error);
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  // Fetch unavailable dates on component mount
  useEffect(() => {
    fetchUnavailableDates("ramassage");
  }, []);

  // Fetch unavailable dates for a specific service type
  const fetchUnavailableDates = async (serviceType = "ramassage") => {
    try {
      console.log(`Fetching unavailable dates for ${serviceType}...`);
      const response = await fetch(
        `${API_BASE_URL}/service-unavailable-date?serviceType=${serviceType}`
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Unavailable dates fetched:", data);
        setUnavailableDates(data.data?.unavailableDates || []);
        return data.data?.unavailableDates || [];
      } else {
        console.warn("Failed to fetch unavailable dates");
        return [];
      }
    } catch (error) {
      console.error("Error fetching unavailable dates:", error);
      return [];
    }
  };
  // Dans votre fonction qui gère la soumission du formulaire de ramassage
  const handleRamassageSubmit = async (formData) => {
    console.log("📦 Données du formulaire ramassage:", formData);

    try {
      const response = await fetch(`${API_BASE_URL}/demandes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          serviceType: "ramassage", // S'assurer que c'est bien envoyé
        }),
      });

      console.log("📦 Réponse du serveur:", {
        status: response.status,
        statusText: response.statusText,
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("📦 Erreur du serveur:", errorData);
        throw new Error(
          errorData.message || "Erreur lors de la création de la demande"
        );
      }

      const result = await response.json();
      console.log("📦 Succès - Données créées:", result);
      return result;
    } catch (error) {
      console.error("📦 Erreur complète:", error);
      throw error;
    }
  };
  // Check date availability using the specific API endpoint
  const checkDateAvailability = async (date, serviceType = "ramassage") => {
    try {
      console.log(
        `Checking availability for date: ${date}, serviceType: ${serviceType}`
      );

      const response = await fetch(
        `${API_BASE_URL}/service-unavailable-date/check-availability?date=${date}&serviceType=${serviceType}`
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Date availability check result:", data);

        if (data.statusCode === 200) {
          return {
            isAvailable: data.data.isAvailable,
            message: data.data.message,
          };
        }
      } else {
        console.warn("Failed to check date availability");
        return { isAvailable: true, message: "Could not verify availability" };
      }
    } catch (error) {
      console.error("Error checking date availability:", error);
      return { isAvailable: true, message: "Error checking availability" };
    }

    return { isAvailable: true, message: "Default to available" };
  };

  // Check if a specific date is unavailable
  const isDateUnavailableCheck = (dateToCheck) => {
    if (!unavailableDates.length) return false;

    return unavailableDates.some((dateRange) => {
      const startDate = new Date(dateRange.startDate);
      const endDate = new Date(dateRange.endDate);
      const checkDate = new Date(dateToCheck);

      return checkDate >= startDate && checkDate <= endDate;
    });
  };

  // Check if a date range overlaps with unavailable dates
  const isDateRangeUnavailable = (startDate, endDate) => {
    if (!unavailableDates.length) return false;

    const rangeStart = new Date(startDate);
    const rangeEnd = new Date(endDate);

    return unavailableDates.some((dateRange) => {
      const unavailableStart = new Date(dateRange.startDate);
      const unavailableEnd = new Date(dateRange.endDate);

      return (
        (rangeStart <= unavailableEnd && rangeEnd >= unavailableStart) ||
        (unavailableStart <= rangeEnd && unavailableEnd >= rangeStart)
      );
    });
  };

  // Handle date selection with API availability check
  const handleDateSelection = async (selectedDate) => {
    console.log(`Date selected: ${selectedDate}`);

    setFormData((prev) => ({
      ...prev,
      date_ramassage: selectedDate,
      date_debut_custom: "",
      date_fin_custom: "",
    }));

    const availabilityResult = await checkDateAvailability(
      selectedDate,
      "ramassage"
    );
    console.log("Date availability result:", availabilityResult);

    const unavailable = !availabilityResult.isAvailable;
    setIsDateUnavailable(unavailable);

    if (unavailable) {
      console.log("Date is unavailable, showing custom date range fields");
      alert(
        `Cette date n'est pas disponible. ${
          availabilityResult.message ||
          "Veuillez choisir une autre date ou spécifier un intervalle de dates préféré."
        }`
      );

      await fetchUnavailableDates("ramassage");
    } else {
      console.log("Date is available, proceeding normally");
    }
  };

  // Handle custom date range selection with validation
  const handleCustomDateRange = (startDate, endDate) => {
    console.log(`Custom date range selected: ${startDate} to ${endDate}`);

    setFormData((prev) => ({
      ...prev,
      date_debut_custom: startDate,
      date_fin_custom: endDate,
    }));

    const unavailable = isDateRangeUnavailable(startDate, endDate);
    console.log("Custom date range availability check:", {
      unavailable,
      startDate,
      endDate,
    });

    if (unavailable) {
      console.log("Custom date range overlaps with unavailable dates");
      alert(
        "Une partie de votre intervalle de dates chevauche des dates indisponibles. Veuillez ajuster votre sélection."
      );
    }
  };

  // Suggest alternative available dates
  const suggestAvailableDates = () => {
    if (!unavailableDates.length) return [];

    const unavailableRanges = unavailableDates.map((range) => ({
      start: new Date(range.startDate),
      end: new Date(range.endDate),
    }));

    unavailableRanges.sort((a, b) => a.start - b.start);

    const availableRanges = [];
    let currentDate = new Date();

    for (const range of unavailableRanges) {
      if (currentDate < range.start) {
        availableRanges.push({
          start: new Date(currentDate),
          end: new Date(range.start.getTime() - 24 * 60 * 60 * 1000),
        });
      }
      currentDate = new Date(range.end.getTime() + 24 * 60 * 60 * 1000);
    }

    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);

    if (currentDate < maxDate) {
      availableRanges.push({
        start: new Date(currentDate),
        end: new Date(maxDate),
      });
    }

    return availableRanges;
  };

  // Component to show available date suggestions
  const AvailableDateSuggestions = () => {
    const availableRanges = suggestAvailableDates();

    if (!availableRanges.length || !isDateUnavailable) return null;

    return (
      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <h4 className="font-semibold text-blue-800 mb-2">
          📅 Dates disponibles suggérées:
        </h4>
        <div className="space-y-2">
          {availableRanges.slice(0, 3).map((range, index) => (
            <div key={index} className="text-sm text-blue-700">
              {range.start.toLocaleDateString()} -{" "}
              {range.end.toLocaleDateString()}
            </div>
          ))}
        </div>
        {availableRanges.length > 3 && (
          <p className="text-xs text-blue-600 mt-2">
            Et {availableRanges.length - 3} autres plages disponibles...
          </p>
        )}
      </div>
    );
  };

  // Create or get address helper
  // FONCTION createOrGetAddress CORRIGÉE
  const createOrGetAddress = async (addressData, addressId = null) => {
    try {
      // VALIDATION: S'assurer que l'addressId est un nombre valide
      if (addressId && !isNaN(parseInt(addressId))) {
        const numericAddressId = parseInt(addressId);
        console.log(`Using existing address ID: ${numericAddressId}`);

        const response = await fetch(
          `${API_BASE_URL}/address/${numericAddressId}`
        );

        if (response.ok) {
          const result = await response.json();
          if (result.data?.address?.id) {
            const id = parseInt(result.data.address.id);
            console.log("Existing address ID found:", id);
            return id;
          }
        }
        console.warn("Address not found, creating new one");
      }

      // Créer une nouvelle adresse
      console.log("Creating new address:", addressData);

      const response = await fetch(`${API_BASE_URL}/address`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(addressData),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(
          error.message || `Failed to create address: ${response.status}`
        );
      }

      const result = await response.json();
      console.log("Full API response for address creation:", result);

      // EXTRACTION ROBUSTE DE L'ID
      let newAddressId;

      // Essayer différentes structures de réponse possibles
      if (result.data?.address?.id !== undefined) {
        newAddressId = result.data.address.id;
      } else if (result.address?.id !== undefined) {
        newAddressId = result.address.id;
      } else if (result.id !== undefined) {
        newAddressId = result.id;
      } else if (result.data?.id !== undefined) {
        newAddressId = result.data.id;
      } else {
        console.error("No address ID found in response structure:", result);
        throw new Error(
          "Structure de réponse d'adresse invalide - ID non trouvé"
        );
      }

      // Conversion robuste en nombre
      const numericId = parseInt(newAddressId);
      if (isNaN(numericId)) {
        console.error("Invalid address ID format received:", newAddressId);
        throw new Error(`Format d'ID d'adresse invalide: ${newAddressId}`);
      }

      console.log("Address created successfully, numeric ID:", numericId);
      return numericId;
    } catch (error) {
      console.error("Error creating/getting address:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("=== FORM SUBMISSION STARTED ===");

    if (!validateStep1()) return;

    setLoading(true);

    try {
      // ÉTAPE 1: Uploader les images - GESTION AMÉLIORÉE
      let uploadedImageUrls = [];
      if (uploadedImages.length > 0) {
        try {
          console.log("📤 Uploading images to server...");
          uploadedImageUrls = await uploadImagesToServer();
          console.log("✅ Images uploaded successfully:", uploadedImageUrls);

          // VÉRIFICATION CRITIQUE
          if (uploadedImageUrls.length === 0) {
            console.warn("⚠️ Aucune URL d'image valide après upload");
          }
        } catch (error) {
          console.error("❌ Error uploading images:", error);
          alert("Erreur lors de l'upload des images. Veuillez réessayer.");
          setLoading(false);
          return;
        }
      } else {
        console.warn("⚠️ Aucune image à uploader");
      }

      // ÉTAPE 2: Créer l'adresse
      const pickupAddressData = {
        fullAddress: formData.adresse_ramassage,
        city: formData.ville_ramassage,
        postalCode: formData.cp_ramassage,
        housingType: formData.type_hebergement_ramassage,
        floor: parseInt(formData.etage_ramassage) || 0,
        ascenseur: formData.ascenseur_ramassage === "oui",
        accesDifficile: false,
      };

      const pickupAddressId = await createOrGetAddress(
        pickupAddressData,
        formData.pickupAddressId
      );

      // ÉTAPE 3: Préparer les données des articles
      const selectedCategories = getSelectedCategoriesWithoutSubcategories();
      const selectedItems = Object.entries(itemsState)
        .filter(([id, v]) => {
          const isCategory = categories.some((cat) => cat.id === parseInt(id));
          return v.checked && !isCategory;
        })
        .map(([id, v]) => ({ itemId: parseInt(id), quantity: v.quantity }));

      // CORRECTION: Créer le texte des catégories sélectionnées pour les notes
      const categoriesText = selectedCategories
        .map((cat) => `${cat.name} x${cat.quantity}`)
        .join(", ");

      const notesWithCategories = categoriesText
        ? `${formData.notes || ""} ${
            formData.notes ? "| " : ""
          }Catégories: ${categoriesText}`.trim()
        : formData.notes;

      console.log("📝 Notes avec catégories:", notesWithCategories);
      let finalGuestToken = guestToken;

      if (!isAuthenticated) {
        // S'assurer qu'un guestToken existe
        if (!finalGuestToken) {
          finalGuestToken = manageGuestToken();
          setGuestToken(finalGuestToken);
        }
        console.log("🎫 Using guest token for submission:", finalGuestToken);
      }
      // ÉTAPE 4: Préparer le payload CORRECT avec gestion des images
      const demandPayload = {
        serviceType: "ramassage",
        serviceDate:
          isDateUnavailable && formData.date_debut_custom
            ? formData.date_debut_custom
            : formData.date_ramassage,
        timeSlot: mapTimeSlotToEnum(formData.plage_horaire),
        notes: notesWithCategories, // ← ICI: notes incluent maintenant les catégories
        consentRgpd: Boolean(formData.rgpd),
        pickupAddressId: parseInt(pickupAddressId),

        // Articles et catégories
        items: selectedItems,
        categories: selectedCategories.map((cat) => ({
          categoryId: cat.id,
          quantity: cat.quantity,
        })),

        // Services supplémentaires
        extraServiceIds: getExtraServiceIdsByNames(formData.services || []),

        // Dates préférées (si date non disponible)
        preferredStartDate: isDateUnavailable
          ? formData.date_debut_custom
          : formData.date_ramassage,
        preferredEndDate: isDateUnavailable
          ? formData.date_fin_custom
          : formData.date_ramassage,

        // Structure des images
        images:
          uploadedImageUrls.length > 0
            ? uploadedImageUrls.map((url) => ({
                url: url,
                alt: `Image du ramassage ${new Date().toISOString()}`,
              }))
            : [],

        // ✅ Conversion snake_case (formData) → camelCase attendu par l'API
        nombreCamions: formData.nombre_camions
          ? parseInt(formData.nombre_camions, 10)
          : undefined,
        nombreDemenageurs: formData.nombre_demenageurs
          ? parseInt(formData.nombre_demenageurs, 10)
          : undefined,
        descriptionManuelle: formData.description_manuelle || undefined,

        // Informations client
        clientFirstName: formData.prenom,
        clientLastName: formData.nom,
        clientEmail: formData.email,
        clientPhone: formData.telephone,

        // User ID si connecté
        ...(isAuthenticated &&
          userId && {
            userId: typeof userId === "number" ? userId.toString() : userId,
          }),
      };

      // DEBUG: Vérifier le payload final avec les images
      console.log("=== FINAL PAYLOAD WITH IMAGES ===", {
        ...demandPayload,
        images: demandPayload.images,
      });

      // ÉTAPE 5: Envoyer la requête avec meilleure gestion d'erreurs
      const response = await fetch(`${API_BASE_URL}/demandes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(demandPayload),
      });

      console.log("Response status:", response.status);

      if (!response.ok) {
        let errorMessage = `Erreur serveur: ${response.status}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
          console.error("📦 Détails de l'erreur:", errorData);
        } catch (parseError) {
          const errorText = await response.text();
          console.error("📦 Erreur texte:", errorText);
          errorMessage = `${errorMessage} - ${errorText}`;
        }
        throw new Error(errorMessage);
      }

      const result = await response.json();
      console.log("✅ Success - Full response:", result);

      // Vérifier que les images sont bien enregistrées
      if (result.data && result.data.demande) {
        console.log("📸 Images dans la réponse:", result.data.demande.images);
        console.log("📝 Notes dans la réponse:", result.data.demande.notes);
      }

      setShowConfirmation(true);

      // Réinitialiser le formulaire après succès
      setUploadedImages([]);
      setItemsState((prev) => {
        const newState = { ...prev };
        Object.keys(newState).forEach((key) => {
          newState[key] = { ...newState[key], checked: false, quantity: 1 };
        });
        return newState;
      });
      setFormData({
        prenom: "",
        nom: "",
        email: "",
        telephone: "",
        adresse_ramassage: "",
        ville_ramassage: "",
        cp_ramassage: "",
        services: [],
        notes: "",
        rgpd: false,
        date_ramassage: "",
        plage_horaire: "",
        type_hebergement_ramassage: "",
        etage_ramassage: "",
        ascenseur_ramassage: "",
        date_debut_custom: "",
        date_fin_custom: "",
        pickupAddressId: null,
      });
    } catch (error) {
      console.error("❌ Submission error:", error);
      alert(`Erreur lors de l'envoi: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  // Ajouter aussi cette fonction utilitaire pour debugger
  const debugImageUpload = () => {
    console.log("=== DEBUG IMAGE UPLOAD ===");
    console.log("Uploaded images array:", uploadedImages);
    console.log(
      "Image files:",
      uploadedImages.map((img) => ({
        name: img.file.name,
        size: img.file.size,
        type: img.file.type,
      }))
    );
  };
  // Get extra service IDs by names
  const getExtraServiceIdsByNames = (serviceNames) => {
    if (!serviceNames || serviceNames.length === 0) return [];
    if (!extraServices || extraServices.length === 0) {
      console.warn("No extra services available");
      return [];
    }

    const serviceIds = [];
    for (const serviceName of serviceNames) {
      if (!serviceName || typeof serviceName !== "string") {
        console.warn(`Invalid service name: ${serviceName}`);
        continue;
      }

      const service = extraServices.find(
        (s) =>
          s &&
          s.name &&
          s.name.toLowerCase().trim() === serviceName.toLowerCase().trim()
      );
      if (service && service.id) {
        serviceIds.push(service.id);
      } else {
        console.warn(`Service not found: ${serviceName}`);
      }
    }
    console.log("Mapped service IDs:", serviceIds);
    return serviceIds;
  };

  // Map time slot to correct format
  const mapTimeSlotToEnum = (timeSlotString) => {
    const timeSlotMap = {
      "08:00 – 10:00": "08:00-10:00",
      "10:00 – 12:00": "10:00-12:00",
      "12:00 – 14:00": "12:00-14:00",
      "14:00 – 16:00": "14:00-16:00",
      "16:00 – 18:00": "16:00-18:00",
    };
    return timeSlotMap[timeSlotString] || "08:00-10:00";
  };

  // Fonction pour obtenir les catégories sans sous-catégories sélectionnées
  const getSelectedCategoriesWithoutSubcategories = () => {
    const selectedCategories = [];

    categories.forEach((category) => {
      // Vérifier si cette catégorie n'a PAS de sous-catégories
      const hasNoSubcategories = getItemsForCategory(category.id).length === 0;

      if (hasNoSubcategories) {
        // Vérifier si cette catégorie est sélectionnée
        const categoryState = itemsState[category.id];
        if (categoryState && categoryState.checked) {
          selectedCategories.push({
            id: category.id,
            name: category.name,
            icon: category.icon,
            quantity: categoryState.quantity,
          });
        }
      }
    });

    return selectedCategories;
  };

  // Form validation for step 1 with date validation
  const validateStep1 = () => {
    const requiredFields = [
      "adresse_ramassage",
      "ville_ramassage",
      "cp_ramassage",
    ];
    requiredFields.push("prenom", "nom", "email");

    if (!isAuthenticated || !formData.telephone) {
      requiredFields.push("telephone");
    }

    if (isDateUnavailable) {
      requiredFields.push("date_debut_custom", "date_fin_custom");
    } else {
      requiredFields.push("date_ramassage");
    }

    let isValid = true;

    requiredFields.forEach((fieldName) => {
      const field = fieldRefs.current[fieldName];
      if (!formData[fieldName]) {
        isValid = false;
        if (field) {
          field.style.borderColor = "#ef4444";
        }
      } else if (field) {
        field.style.borderColor = "#d1d5db";
      }
    });

    if (!isValid) {
      alert("Veuillez remplir tous les champs obligatoires.");
    }

    return isValid;
  };

  // Get items for a specific category
  const getItemsForCategory = (categoryId) => {
    return categoryItems.filter((item) => item.category.id === categoryId);
  };

  // Toggle item selection
  const toggleItem = (itemId) => {
    setItemsState((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        checked: !prev[itemId].checked,
      },
    }));
  };

  // Increase item quantity
  const increaseQuantity = (itemId) => {
    setItemsState((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        quantity: prev[itemId].quantity + 1,
      },
    }));
  };

  // Decrease item quantity
  const decreaseQuantity = (itemId) => {
    setItemsState((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        quantity: Math.max(1, prev[itemId].quantity - 1),
      },
    }));
  };

  // Toggle summary display
  const handleShowSummary = () => {
    const selectedCategories = getSelectedCategoriesWithoutSubcategories();

    if (selectedCategories.length > 0 || showSummary) {
      setShowSummary(!showSummary);
    } else {
      alert("Aucune catégorie sélectionnée à afficher dans le résumé.");
    }
  };

  const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 1));

  // Select/deselect all items
  const selectAll = () => {
    const newItemsState = { ...itemsState };
    Object.keys(newItemsState).forEach((key) => {
      newItemsState[key] = { ...newItemsState[key], checked: true };
    });
    setItemsState(newItemsState);
  };

  const deselectAll = () => {
    const newItemsState = { ...itemsState };
    Object.keys(newItemsState).forEach((key) => {
      newItemsState[key] = {
        ...newItemsState[key],
        checked: false,
        quantity: 1,
      };
    });
    setItemsState(newItemsState);
  };

  // Handle service checkbox change
  const handleServiceChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      let services = Array.isArray(prev.services) ? [...prev.services] : [];
      if (checked) {
        if (!services.includes(value)) {
          services.push(value);
        }
      } else {
        services = services.filter((s) => s !== value);
      }
      return { ...prev, services };
    });
  };

  // Handle input changes with enhanced date validation
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    console.log(`Input changed: ${name} = ${value}`);

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "date_ramassage" && value) {
      console.log("Date input changed, checking availability...");
      handleDateSelection(value);
    }

    if (name === "date_debut_custom" && value) {
      console.log("Custom start date changed:", value);
      handleCustomDateRange(value, formData.date_fin_custom);
    }

    if (name === "date_fin_custom" && value) {
      console.log("Custom end date changed:", value);
      handleCustomDateRange(formData.date_debut_custom, value);
    }
  };

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4">Chargement...</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <br />
      <br />
      <br />

      {/* Header Hero Section */}
      <div className="hero-gradient text-white py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold mb-4">
              Demande de Soumission - Ramassage
            </h1>
            <p className="text-xl text-blue-100 mb-8">
              Obtenez votre devis personnalisé en quelques minutes
            </p>
            <div className="flex justify-center items-center space-x-8 text-sm">
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Devis gratuit
              </div>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Réponse sous 24h
              </div>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                100% sécurisé
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 -mt-8 relative z-10">
        {/* Progress Steps */}
        <div className="bg-white rounded-2xl card-shadow p-6 mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-4">
            <div
              className={`flex items-center rounded-full px-4 sm:px-6 py-2 sm:py-3 font-semibold ${
                currentStep === 1
                  ? "step-active"
                  : currentStep > 1
                  ? "step-completed"
                  : "bg-gray-200 text-gray-600"
              }`}
            >
              <span
                className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center mr-2 sm:mr-3 text-sm ${
                  currentStep === 1
                    ? "bg-white bg-opacity-20"
                    : currentStep > 1
                    ? "bg-white bg-opacity-20"
                    : "bg-gray-400 text-white"
                }`}
              >
                1
              </span>
              Informations de base
            </div>

            <div className="hidden md:flex flex-1 h-1 bg-gray-200 mx-4">
              <div
                className="h-full bg-blue-500 progress-bar transition-all"
                style={{ width: currentStep >= 2 ? "100%" : "33%" }}
              ></div>
            </div>

            <div
              className={`flex items-center rounded-full px-4 sm:px-6 py-2 sm:py-3 font-semibold ${
                currentStep === 2
                  ? "step-active"
                  : currentStep > 2
                  ? "step-completed"
                  : "bg-gray-200 text-gray-600"
              }`}
            >
              <span
                className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center mr-2 sm:mr-3 text-sm ${
                  currentStep === 2
                    ? "bg-white bg-opacity-20"
                    : currentStep > 2
                    ? "bg-white bg-opacity-20"
                    : "bg-gray-400 text-white"
                }`}
              >
                2
              </span>
              Détails
            </div>

            <div className="hidden md:flex flex-1 h-1 bg-gray-200 mx-4">
              <div
                className="h-full bg-blue-500 progress-bar transition-all"
                style={{ width: currentStep >= 3 ? "100%" : "0%" }}
              ></div>
            </div>

            <div
              className={`flex items-center rounded-full px-4 sm:px-6 py-2 sm:py-3 font-semibold ${
                currentStep === 3 ? "step-active" : "bg-gray-200 text-gray-600"
              }`}
            >
              <span
                className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center mr-2 sm:mr-3 text-sm ${
                  currentStep === 3
                    ? "bg-white bg-opacity-20"
                    : "bg-gray-400 text-white"
                }`}
              >
                3
              </span>
              Services & Finalisation
            </div>
          </div>
        </div>

        {/* Main Form */}
        <div className="bg-white rounded-2xl card-shadow overflow-hidden">
          <form id="devisForm" className="p-8" onSubmit={handleSubmit}>
            {/* Step 1: Basic Information */}
            <div className={currentStep === 1 ? "slide-in" : "hidden"}>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                {/* Personal Information */}
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                      <svg
                        className="w-5 h-5 text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        ></path>
                      </svg>
                    </div>
                    Informations personnelles
                  </h2>

                  {isAuthenticated ? (
                    <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                      <p className="text-sm text-green-700 mb-2">
                        ✅ Vous êtes connecté. Vos informations personnelles
                        sont pré-remplies.
                      </p>
                      <div className="grid grid-cols-2 gap-2 text-xs">
                        <div>
                          <strong>Nom:</strong>{" "}
                          {formData.nom || "Non disponible"}
                        </div>
                        <div>
                          <strong>Prénom:</strong>{" "}
                          {formData.prenom || "Non disponible"}
                        </div>
                        <div>
                          <strong>Email:</strong>{" "}
                          {formData.email || "Non disponible"}
                        </div>
                        <div>
                          <strong>Téléphone:</strong>{" "}
                          {formData.telephone || "Non disponible"}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                      <p className="text-sm text-blue-700">
                        💡 Vous n'êtes pas connecté. Vos informations seront
                        utilisées uniquement pour cette demande.
                      </p>
                    </div>
                  )}

                  <div className="space-y-6">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="input-group relative transition-all duration-300">
                        <input
                          type="text"
                          name="prenom"
                          value={formData.prenom}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-4 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none peer"
                          ref={(el) => (fieldRefs.current.prenom = el)}
                        />
                        <label
                          htmlFor="prenom"
                          className={`floating-label ${
                            formData.prenom ? "active" : ""
                          }`}
                        >
                          Prénom *
                        </label>
                      </div>
                      <div className="input-group relative transition-all duration-300">
                        <input
                          type="text"
                          name="nom"
                          value={formData.nom}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-4 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none peer"
                          ref={(el) => (fieldRefs.current.nom = el)}
                        />
                        <label
                          htmlFor="nom"
                          className={`floating-label ${
                            formData.nom ? "active" : ""
                          }`}
                        >
                          Nom *
                        </label>
                      </div>
                    </div>

                    <div className="input-group relative transition-all duration-300">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-4 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none peer"
                        ref={(el) => (fieldRefs.current.email = el)}
                      />
                      <label
                        htmlFor="email"
                        className={`floating-label ${
                          formData.email ? "active" : ""
                        }`}
                      >
                        Adresse courriel *
                      </label>
                    </div>

                    <div className="input-group relative transition-all duration-300">
                      <input
                        type="tel"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        required={!isAuthenticated || !formData.telephone}
                        className="w-full px-4 py-4 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none peer"
                        ref={(el) => (fieldRefs.current.telephone = el)}
                      />
                      <label
                        htmlFor="telephone"
                        className={`floating-label ${
                          formData.telephone ? "active" : ""
                        }`}
                      >
                        Numéro de téléphone{" "}
                        {!isAuthenticated || !formData.telephone ? "*" : ""}
                      </label>
                    </div>
                  </div>
                </div>

                {/* Date & Time Section */}
                <div className="border-2 border-purple-200 rounded-xl p-6 bg-purple-50">
                  <h3 className="font-semibold text-purple-800 mb-4 flex items-center">
                    <span className="text-2xl mr-2">🗓️</span>
                    Date & Horaire de ramassage
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="input-group relative transition-all duration-300">
                      <input
                        type="date"
                        name="date_ramassage"
                        value={formData.date_ramassage}
                        onChange={handleInputChange}
                        onFocus={() => fetchUnavailableDates("ramassage")}
                        required
                        min={new Date().toISOString().split("T")[0]}
                        className="w-full px-4 py-4 border-2 border-purple-200 rounded-lg focus:border-purple-500 focus:outline-none bg-white"
                      />
                    </div>

                    {!isDateUnavailable && formData.date_ramassage && (
                      <div className="input-group relative transition-all duration-300">
                        <select
                          name="plage_horaire"
                          value={formData.plage_horaire}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-4 border-2 border-purple-200 rounded-lg focus:border-purple-500 focus:outline-none bg-white"
                        >
                          <option value="">
                            Sélectionner une plage horaire
                          </option>
                          <option value="08:00 – 10:00">08:00 – 10:00</option>
                          <option value="10:00 – 12:00">10:00 – 12:00</option>
                          <option value="12:00 – 14:00">12:00 – 14:00</option>
                          <option value="14:00 – 16:00">14:00 – 16:00</option>
                          <option value="16:00 – 18:00">16:00 – 18:00</option>
                        </select>
                      </div>
                    )}
                  </div>

                  {isDateUnavailable && formData.date_ramassage && (
                    <div className="mt-4 space-y-4">
                      <div className="p-4 border border-orange-300 bg-orange-50 rounded-lg text-orange-700">
                        ⚠️ Cette date n'est pas disponible pour les créneaux
                        standards.
                        <br />
                        👉 Veuillez spécifier un intervalle de dates préféré :
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="input-group relative">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Date de début souhaitée
                          </label>
                          <input
                            type="date"
                            name="date_debut_custom"
                            value={formData.date_debut_custom || ""}
                            onChange={handleInputChange}
                            required={isDateUnavailable}
                            min={new Date().toISOString().split("T")[0]}
                            className="w-full px-4 py-4 border-2 border-orange-200 rounded-lg focus:border-orange-500 focus:outline-none bg-white"
                          />
                        </div>

                        <div className="input-group relative">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Date de fin souhaitée
                          </label>
                          <input
                            type="date"
                            name="date_fin_custom"
                            value={formData.date_fin_custom || ""}
                            onChange={handleInputChange}
                            required={isDateUnavailable}
                            min={
                              formData.date_debut_custom ||
                              new Date().toISOString().split("T")[0]
                            }
                            className="w-full px-4 py-4 border-2 border-orange-200 rounded-lg focus:border-orange-500 focus:outline-none bg-white"
                          />
                        </div>
                      </div>

                      <AvailableDateSuggestions />
                    </div>
                  )}
                </div>
              </div>

              {/* Pickup Address Section */}
              <div className="mt-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <svg
                      className="w-5 h-5 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                  </div>
                  Adresse de ramassage
                </h2>

                <div className="border-2 border-green-200 rounded-xl p-6 bg-green-50">
                  <h3 className="font-semibold text-green-800 mb-4 flex items-center">
                    <span className="text-2xl mr-2">🏠</span>
                    Adresse de ramassage
                  </h3>
                  <div className="space-y-4">
                    <div className="input-group relative transition-all duration-300">
                      <input
                        type="text"
                        name="adresse_ramassage"
                        value={formData.adresse_ramassage}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-4 border-2 border-green-200 rounded-lg focus:border-green-500 focus:outline-none peer bg-white"
                        ref={(el) => (fieldRefs.current.adresse_ramassage = el)}
                      />
                      <label
                        htmlFor="adresse_ramassage"
                        className={`floating-label ${
                          formData.adresse_ramassage ? "active" : ""
                        }`}
                      >
                        Adresse complète *
                      </label>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div className="input-group relative transition-all duration-300">
                        <input
                          type="text"
                          name="ville_ramassage"
                          value={formData.ville_ramassage}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-4 border-2 border-green-200 rounded-lg focus:border-green-500 focus:outline-none peer bg-white"
                          ref={(el) => (fieldRefs.current.ville_ramassage = el)}
                        />
                        <label
                          htmlFor="ville_ramassage"
                          className={`floating-label ${
                            formData.ville_ramassage ? "active" : ""
                          }`}
                        >
                          Ville *
                        </label>
                      </div>
                      <div className="input-group relative transition-all duration-300">
                        <input
                          type="text"
                          name="cp_ramassage"
                          value={formData.cp_ramassage}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-4 border-2 border-green-200 rounded-lg focus:border-green-500 focus:outline-none peer bg-white"
                          ref={(el) => (fieldRefs.current.cp_ramassage = el)}
                        />
                        <label
                          htmlFor="cp_ramassage"
                          className={`floating-label ${
                            formData.cp_ramassage ? "active" : ""
                          }`}
                        >
                          Code postal *
                        </label>
                      </div>
                    </div>

                    <div className="input-group relative transition-all duration-300">
                      <select
                        name="type_hebergement_ramassage"
                        value={formData.type_hebergement_ramassage}
                        onChange={handleInputChange}
                        className="w-full px-4 py-4 border-2 border-green-200 rounded-lg focus:border-green-500 focus:outline-none bg-white"
                      >
                        <option value="">Type d'hébergement</option>
                        <option value="Appartement">Appartement</option>
                        <option value="Maison">Maison</option>
                        <option value="Bureau">Bureau</option>
                      </select>
                    </div>

                    <div className="input-group relative transition-all duration-300">
                      <input
                        type="number"
                        name="etage_ramassage"
                        min="0"
                        value={formData.etage_ramassage}
                        onChange={handleInputChange}
                        className="w-full px-4 py-4 border-2 border-green-200 rounded-lg focus:border-green-500 focus:outline-none bg-white"
                      />
                      <label
                        htmlFor="etage_ramassage"
                        className={`floating-label ${
                          formData.etage_ramassage ? "active" : ""
                        }`}
                      >
                        Étage
                      </label>
                    </div>

                    <div>
                      <span className="block font-medium text-green-800 mb-2">
                        Ascenseur
                      </span>
                      <div className="flex items-center space-x-6">
                        <label className="flex items-center space-x-2">
                          <input
                            type="radio"
                            name="ascenseur_ramassage"
                            value="oui"
                            checked={formData.ascenseur_ramassage === "oui"}
                            onChange={handleInputChange}
                          />
                          <span>Oui</span>
                        </label>
                        <label className="flex items-center space-x-2">
                          <input
                            type="radio"
                            name="ascenseur_ramassage"
                            value="non"
                            checked={formData.ascenseur_ramassage === "non"}
                            onChange={handleInputChange}
                          />
                          <span>Non</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

{/* Besoins logistiques */}
<div className="mt-8 border-2 border-yellow-200 rounded-xl p-6 bg-yellow-50">
  <h3 className="font-semibold text-yellow-800 mb-4 flex items-center">
    <span className="text-2xl mr-2">🚚</span>
    Besoins logistiques
  </h3>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="input-group relative">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Nombre de camions
      </label>
      <input
        type="number"
        name="nombre_camions"
        min="1"
        value={formData.nombre_camions}
        onChange={handleInputChange}
        placeholder="Ex: 1"
        className="w-full px-4 py-4 border-2 border-yellow-200 rounded-lg focus:border-yellow-500 focus:outline-none bg-white"
      />
    </div>
    <div className="input-group relative">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Nombre de ramasseurs
      </label>
      <input
        type="number"
        name="nombre_demenageurs"
        min="1"
        value={formData.nombre_demenageurs}
        onChange={handleInputChange}
        placeholder="Ex: 2"
        className="w-full px-4 py-4 border-2 border-yellow-200 rounded-lg focus:border-yellow-500 focus:outline-none bg-white"
      />
    </div>
  </div>

</div>

              <div className="flex justify-end mt-12">
                <button
                  type="button"
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" }); // scroll to top
                    nextStep(); // call your existing function
                  }}
                  className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center shadow-md"
                >
                  Continuer
                  <svg
                    className="w-5 h-5 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>

            {/* Step 2: Items Selection */}
            <div className={currentStep === 2 ? "slide-in" : "hidden"}>
              <div className="container mx-auto px-4 py-8 max-w-4xl">
                <div className="bg-white rounded-2xl shadow-xl p-8 mb-1">
                  <h1 className="text-3xl font-bold text-gray-800 mb-1 text-center">
                    📦 Liste des Articles à Ramasser
                  </h1>

                  {!modeSelection && (
                    <p className="text-center text-gray-600 mt-2 mb-2">
                      👇 Veuillez choisir comment vous souhaitez indiquer vos
                      articles :
                    </p>
                  )}

                  <div className="flex justify-center gap-4 mt-4 mb-6">
                    <button
                      type="button"
                      onClick={() => setModeSelection("articles")}
                      className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-md ${
                        modeSelection === "articles"
                          ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      📦 Articles
                    </button>
                    <button
                      type="button"
                      onClick={() => setModeSelection("manuelle")}
                      className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-md ${
                        modeSelection === "manuelle"
                          ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      ✍️ Description manuelle
                    </button>
                  </div>

                  {/* Résumé simple */}
                  {showSummary && modeSelection === "articles" && (
                    <div className="mb-6 p-4 bg-gray-100 rounded-lg">
                      <h3 className="font-bold mb-2">
                        Résumé des catégories sélectionnées :
                      </h3>
                      {getSelectedCategoriesWithoutSubcategories().length >
                      0 ? (
                        <ul className="space-y-1">
                          {getSelectedCategoriesWithoutSubcategories().map(
                            (category) => (
                              <li
                                key={category.id}
                                className="flex justify-between"
                              >
                                <span>
                                  {category.icon} {category.name}
                                </span>
                                <span>x{category.quantity}</span>
                              </li>
                            )
                          )}
                        </ul>
                      ) : (
                        <p className="text-gray-500">
                          Aucune catégorie sélectionnée
                        </p>
                      )}
                    </div>
                  )}
                </div>

                {modeSelection === "articles" && (
                <>
                {/* Affichage des catégories sans sous-catégories */}
                <div className="mb-10">
                  <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
                    📦 Catégories disponibles
                  </h2>

                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {categories
                      .filter(
                        (category) =>
                          getItemsForCategory(category.id).length === 0
                      )
                      .map((category) => (
                        <div
                          key={category.id}
                          className={`cursor-pointer border rounded-2xl p-6 flex flex-col items-center justify-center text-center shadow-md transition-all duration-200
                            ${
                              itemsState[category.id]?.checked
                                ? "bg-green-100 border-green-500 scale-105"
                                : "bg-white border-gray-200 hover:shadow-lg hover:scale-105"
                            }`}
                          onClick={() => toggleItem(category.id)}
                        >
                          <div className="text-4xl mb-3">
                            {category.icon || "📦"}
                          </div>
                          <span className="font-semibold text-gray-800">
                            {category.name}
                          </span>
                        </div>
                      ))}
                  </div>

                  {/* Résumé final */}
                  {getSelectedCategoriesWithoutSubcategories().length > 0 && (
                    <div className="mt-10 bg-gray-50 p-6 rounded-xl shadow-inner">
                      <h3 className="text-lg font-bold text-gray-800 mb-4">
                        📝 Résumé final - Catégories sélectionnées
                      </h3>

                      <ul className="space-y-2">
                        {getSelectedCategoriesWithoutSubcategories().map(
                          (category) => (
                            <li
                              key={category.id}
                              className="flex justify-between items-center bg-white rounded-lg shadow p-3"
                            >
                              <div className="flex items-center space-x-2">
                                <span className="text-xl">{category.icon}</span>
                                <span>{category.name}</span>
                              </div>
                            </li>
                          )
                        )}
                      </ul>

                      <div className="mt-4 pt-4 border-t border-gray-300">
                        <div className="flex justify-between items-center font-semibold text-lg">
                          <span>Total des catégories :</span>
                          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full">
                            {getSelectedCategoriesWithoutSubcategories().length}{" "}
                            catégories
                          </span>
                        </div>
                        <div className="flex justify-between items-center mt-2 text-gray-600">
                          <span>Quantité totale :</span>
                          <span className="font-semibold">
                            {getSelectedCategoriesWithoutSubcategories().reduce(
                              (total, category) => total + category.quantity,
                              0
                            )}{" "}
                            unités
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                </>
                )}

                {/* ============================================ */}
                {/* MODE DESCRIPTION MANUELLE : champ texte      */}
                {/* ============================================ */}
                {modeSelection === "manuelle" && (
                  <div className="w-full max-w-3xl mx-auto py-6">
                    <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-blue-200">
                      <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                        <span className="text-2xl mr-2">✍️</span>
                        Décrivez vos articles à ramasser
                      </h2>
                      <textarea
                        name="description_manuelle"
                        value={formData.description_manuelle}
                        onChange={handleInputChange}
                        rows="8"
                        placeholder="Ex: 1 vieux frigo, 2 matelas, 5 boîtes de vêtements..."
                        className="w-full rounded-lg border-2 border-gray-300 px-4 py-3 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                      ></textarea>
                      <p className="text-sm text-gray-500 mt-2">
                        Listez librement vos articles avec leurs quantités.
                      </p>
                    </div>
                  </div>
                )}

                {/* SECTION UPLOAD D'IMAGES OBLIGATOIRE */}
                <div className="mb-8 bg-white rounded-2xl shadow-xl p-8 border-2 border-blue-200">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center text-center justify-center">
                    <span className="text-3xl mr-3">📸</span>
                    Photos des articles à ramasser *
                  </h2>

                  <div className="text-center mb-6">
                    <p className="text-gray-600 mb-2">
                      <strong>Obligatoire :</strong> Veuillez uploader des
                      photos claires de vos articles
                    </p>
                    <p className="text-sm text-gray-500">
                      Formats acceptés: JPEG, PNG, GIF, WebP (max 5MB par image)
                    </p>
                  </div>

                  {/* Zone de drop et upload */}
                  <div
                    className="border-2 border-dashed border-blue-300 rounded-2xl p-8 text-center bg-blue-50 hover:bg-blue-100 transition-colors cursor-pointer mb-4"
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.add(
                        "border-blue-500",
                        "bg-blue-100"
                      );
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.remove(
                        "border-blue-500",
                        "bg-blue-100"
                      );
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.remove(
                        "border-blue-500",
                        "bg-blue-100"
                      );
                      handleImageUpload({
                        target: { files: e.dataTransfer.files },
                      });
                    }}
                    onClick={() =>
                      document.getElementById("image-upload").click()
                    }
                  >
                    <input
                      id="image-upload"
                      type="file"
                      multiple
                      accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                      onChange={handleImageUpload}
                      className="hidden"
                      ref={(el) => (fieldRefs.current.images = el)}
                    />

                    <div className="text-5xl mb-4">📁</div>
                    <p className="text-lg font-semibold text-blue-700 mb-2">
                      Cliquez ou glissez-déposez vos images ici
                    </p>
                    <p className="text-sm text-blue-600">
                      Minimum 1 image • Maximum 5 images
                    </p>
                  </div>

                  {/* Message d'erreur */}
                  {imageUploadError && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                      <p className="text-red-700 font-medium">
                        {imageUploadError}
                      </p>
                    </div>
                  )}

                  {/* Aperçu des images uploadées */}
                  {uploadedImages.length > 0 && (
                    <div className="mt-6">
                      <h3 className="font-semibold text-gray-800 mb-3">
                        📷 Photos uploadées ({uploadedImages.length}/5)
                      </h3>
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                        {Array.from({ length: 5 }).map((_, index) => {
                          const image = uploadedImages[index];
                          return (
                            <div key={index} className="relative group">
                              {image ? (
                                <>
                                  <img
                                    src={image.preview}
                                    alt={`Preview ${index + 1}`}
                                    className="w-full h-24 object-cover rounded-lg shadow-md"
                                  />
                                  <button
                                    type="button"
                                    onClick={() => removeImage(index)}
                                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold hover:bg-red-600 transition-colors"
                                  >
                                    ×
                                  </button>
                                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs p-1 rounded-b-lg opacity-0 group-hover:opacity-100 transition-opacity">
                                    {image.name}
                                  </div>
                                </>
                              ) : (
                                <div className="w-full h-24 flex items-center justify-center border border-dashed border-gray-300 rounded-lg text-gray-400">
                                  {index + 1}️⃣ Image
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>

                      {uploadedImages.length < 1 && (
                        <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                          <p className="text-red-700 text-sm">
                            ⚠️ Veuillez uploader au moins 1 image.
                          </p>
                        </div>
                      )}

                      {uploadedImages.length > 0 && (
                        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                          <p className="text-green-700 text-sm">
                            ✅ {uploadedImages.length} photo(s) prête(s). Vous
                            pouvez continuer.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="flex justify-between mt-8 px-4 sm:px-6 lg:px-8">
                  <button
                    type="button"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" }); // scroll vers le haut
                      prevStep(); // appel de la fonction précédente
                    }}
                    className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center shadow-md"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                    Retour
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" }); // scroll to top
                      nextStep(); // call your existing function
                    }}
                    className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center shadow-md"
                  >
                    Continuer
                    <svg
                      className="w-5 h-5 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            {/* Step 3: Services and Finalization */}
            <div className={currentStep === 3 ? "animate-fadeIn" : "hidden"}>
              <div className="space-y-10">
                <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
                  <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center mr-4">
                    <svg
                      className="w-5 h-5 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                  </div>
                  Services supplémentaires
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {extraServices && extraServices.length > 0 ? (
                    extraServices.map((service) => {
                      if (!service || !service.id || !service.name) {
                        console.warn("Invalid service object:", service);
                        return null;
                      }

                      return (
                        <div
                          key={service.id}
                          className="border-2 border-gray-200 rounded-xl p-6 hover:border-blue-300 transition-colors"
                        >
                          <label className="flex items-start cursor-pointer">
                            <input
                              type="checkbox"
                              name="services"
                              value={service.name.trim()}
                              checked={formData.services?.includes(
                                service.name.trim()
                              )}
                              onChange={handleServiceChange}
                              className="mt-1 mr-4"
                            />
                            <div>
                              <h3 className="font-semibold text-gray-800 mb-2">
                                {service.icon} {service.name.trim()}
                              </h3>
                              <p className="text-sm text-gray-600">
                                {service.description ||
                                  "Aucune description disponible"}
                              </p>
                            </div>
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-span-2 text-center py-8 text-gray-500">
                      <p>
                        Aucun service supplémentaire disponible pour le moment.
                      </p>
                    </div>
                  )}
                </div>

                {/* Additional Information Section */}
                <div className="form-section space-y-6">
                  <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                    📝 Informations supplémentaires
                  </h2>

                  <div>
                    <label
                      htmlFor="notes"
                      className="block text-sm font-semibold text-gray-700 mb-2"
                    >
                      Commentaires et instructions particulières
                    </label>
                    <textarea
                      id="notes"
                      name="notes"
                      value={formData.notes}
                      onChange={handleInputChange}
                      rows="3"
                      placeholder="Contraintes d'accès, horaires spécifiques, précautions particulières..."
                      className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-blue-400"
                    ></textarea>
                  </div>
                </div>

                {/* RGPD Consent */}
                <div className="mt-8 p-6 bg-gray-50 rounded-xl border-2 border-gray-200">
                  <label className="flex items-start space-x-3 cursor-pointer">
                    <input
                      type="checkbox"
                      name="rgpd"
                      checked={formData.rgpd}
                      onChange={handleInputChange}
                      required
                      className="mt-1 h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                    />
                    <span className="text-sm text-gray-700 leading-relaxed">
                      <strong>Consentement RGPD *</strong>
                      <br />
                      J'accepte que mes données personnelles soient collectées
                      et traitées pour traiter ma demande de devis. Ces données
                      ne seront pas transmises à des tiers et seront supprimées
                      après traitement de ma demande.
                      <br />
                      <em>
                        Vous pouvez à tout moment demander la suppression de vos
                        données en nous contactant.
                      </em>
                    </span>
                  </label>
                </div>

                {/* Important Information */}
                <div className="bg-blue-50 border-l-4 border-blue-500 rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                    ℹ️ Informations importantes
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>✅ Service de ramassage professionnel</li>
                    <li>📦 Prise en charge complète de vos articles</li>
                    <li>🚚 Transport sécurisé avec assurance</li>
                    <li>💼 Devis gratuit et sans engagement</li>
                    <li>⚡ Service disponible 7j/7</li>
                    <li>🔒 Respect total de vos biens</li>
                  </ul>
                </div>

                {/* Summary before submission */}
                {(formData.date_ramassage ||
                  (formData.date_debut_custom && formData.date_fin_custom)) &&
                  getSelectedCategoriesWithoutSubcategories().length > 0 && (
                    <div className="bg-green-50 border-l-4 border-green-500 rounded-xl p-6 shadow-sm">
                      <h3 className="text-lg font-bold text-gray-800 mb-3">
                        📋 Résumé de votre demande
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        <div>
                          <strong>Date souhaitée :</strong>
                          <br />
                          {isDateUnavailable
                            ? `Du ${formData.date_debut_custom} au ${formData.date_fin_custom}`
                            : `${formData.date_ramassage} à ${formData.plage_horaire}`}
                        </div>
                        <div>
                          <strong>Catégories sélectionnées :</strong>
                          <br />
                          {
                            getSelectedCategoriesWithoutSubcategories().length
                          }{" "}
                          catégories
                        </div>
                        <div>
                          <strong>Adresse de ramassage :</strong>
                          <br />
                          {formData.adresse_ramassage},{" "}
                          {formData.ville_ramassage}
                        </div>
                        {formData.services.length > 0 && (
                          <div className="md:col-span-2">
                            <strong>Services supplémentaires :</strong>
                            <br />
                            {formData.services.join(", ")}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
              </div>

              <div className="flex justify-between mt-12">
                <button
                  type="button"
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" }); // scroll vers le haut
                    prevStep(); // appel de la fonction précédente
                  }}
                  className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center shadow-md"
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                  Retour
                </button>

                <button
                  type="submit"
                  disabled={loading}
                  className="bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white px-12 py-4 rounded-lg font-semibold text-lg transition-all duration-300 flex items-center shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                      Envoi en cours...
                    </>
                  ) : (
                    <>
                      <svg
                        className="w-6 h-6 mr-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                        ></path>
                      </svg>
                      Envoyer ma demande
                    </>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* Confirmation Modal */}
        {showConfirmation && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">
                Demande envoyée !
              </h3>
              <p className="text-gray-600 mb-6">
                Votre demande de ramassage a été transmise avec succès. Notre
                équipe vous contactera sous 24h.
              </p>
              <button
                onClick={() => navigate("/")} // "/" = page d'accueil
                className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold"
              >
                Fermer
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Ramassage;